interface DOMElements {
  container: HTMLElement
  toggle: NodeListOf<HTMLElement>
  layer: HTMLElement
}

export class MobileMenu {
  DOM: DOMElements
  active: boolean

  constructor() {
    this.DOM = {
      container: <HTMLElement>document.querySelector('.js-mobile-menu'),
      toggle: document.querySelectorAll('.js-hamburger'),
      layer: <HTMLElement>document.querySelector('.js-navbar-navigation__layer'),
    }

    this.active = false

    this.init()
  }

  private init() {
    this.bindEvents()
  }

  private bindEvents() {
    this.DOM.toggle.forEach(item => item.addEventListener('click', () => this.toggle()))
    this.DOM.layer.addEventListener('click', () => this.toggle())
  }

  private toggle() {
    const method = this.active ? 'remove' : 'add'
    this.DOM.container.classList[method]('is-active')
 
    this.active = !this.active
  }
}
